import { Injectable } from '@nestjs/common';
import { Relations } from '../relation.entity';
import { RelationDTO } from './relation.dto';

@Injectable()
export class RelationsAdapter {
  /**
   *
   * @param relationDTO
   * @returns Relations entity
   */
  public convertDtoToEntity(  relationDTO: RelationDTO,  isUpdate: boolean = false ): Relations {
    const relation = new Relations();
    relation.relationId=relationDTO.relationId;
    relation.relation=relationDTO.relation;
    relation.isActive=relationDTO.isActive==undefined?true:relationDTO.isActive;
    if (isUpdate) {
      relation.updatedUser = relationDTO.updatedUser;
    } else {
      relation.isActive = true;
      relation.createdUser = relationDTO.createdUser;
    }
   return relation;
  }
  public convertEntityToDto(relationObject: Relations): RelationDTO {
    const relationDTO = new RelationDTO;
    relationDTO.relationId = relationObject.relationId;
    relationDTO.relation = relationObject.relation;
    relationDTO.isActive = relationObject.isActive;
    relationDTO.createdAt = relationObject.createdAt;
    relationDTO.updatedAt = relationObject.updatedAt;
    relationDTO.createdUser = relationObject.createdUser;
    relationDTO.updatedUser = relationObject.updatedUser;
    relationDTO.versionFlag = relationObject.versionFlag;
    return relationDTO;
  }
}
